import { useRef, useEffect, useCallback } from 'react';

// Be warned! Passing a normal function as callback will 
// cause the dependency array in this hook to trigger often.
// callback *must* be a useCallback, passed in.
export default function useDebouncedCallback<T extends (...args: any[]) => void>(
	callback: T, 
	delay: number
): (...args: Parameters<T>) => void {
	const timeoutRef = useRef<NodeJS.Timeout | null>(null);

	const debouncedFn = useCallback(
		(...args: Parameters<T>) => {
			if (timeoutRef.current) clearTimeout(timeoutRef.current);
			timeoutRef.current = setTimeout(() => {
				callback(...args);
			}, delay);
		},
		[callback, delay]
	);

	useEffect(() => {
		return () => {
			if (timeoutRef.current) clearTimeout(timeoutRef.current);
		};
	}, []);

	return debouncedFn;
}
